import { createActor } from "xstate5";
import { trpc } from "../trpc/client";
import { createPermissionsStateMachine } from "./get-permissions";

const permissionsStateMachine = createPermissionsStateMachine({
	requiredPermission: [
		"booklist:bulkUpload",
		"booklist:view",
		"booklist:edit",
		"booklist:request",
		"booklist:approve",
		"booklist:autoApprove",
		"catalogue:search",
		"cart:purchase",
		"adoptions:viewAssignedCourses",
		"adoptions:viewAllCourses",
		"adoptions:approve",
		"dashboards:academic",
		"dashboards:acquisitions",
		"dashboards:allTitles",
		"dashboards:bibliotechAdmin",
		"dashboards:uaaSpend",
		"dashboards:engage",
		"permissions:manage",
		"booklist:viewInternalStatus",
		"counterReport:view",
		"campus-store:manage",
	],
	fetchPermissions(requiredPermission) {
		return trpc.user.hasPermissions.query(requiredPermission);
	},
});

export const permissionsActor = createActor(permissionsStateMachine).start();
